import axios from 'axios';
import React, { useReducer } from 'react';
import setAuthToken from '../../utils/setAuthToken';
import {
	AUTH_ERROR,
	LOGIN_FAILURE,
	LOGIN_SUCCESS,
	LOGOUT,
	REGISTER_FAILURE,
	REGISTER_SUCCESS,
	USER_LOADED,
} from '../types';
import AuthContext from './authContext';
import AuthReducer from './authReducer';

const AuthState = (props) => {
	const initialState = {
		token: localStorage.getItem('token'),
		isAuthenticated: null,
		user: null,
		loading: true,
	};

	const [state, dispatch] = useReducer(AuthReducer, initialState);

	// Load User

	const loadUser = async () => {
		if (localStorage.token) {
			setAuthToken(localStorage.token);
		}

		try {
			const res = await axios.get('/api/auth');
			dispatch({
				type: USER_LOADED,
				payload: res.data,
			});
		} catch (err) {
			dispatch({
				type: AUTH_ERROR,
			});
		}
	};

	// Register User

	const register = async ({ name, email, password }) => {
		const config = {
			headers: {
				'Content-Type': 'application/json',
			},
		};

		const body = JSON.stringify({
			name,
			email,
			password,
		});

		try {
			const res = await axios.post('/api/users', body, config);
			dispatch({
				type: REGISTER_SUCCESS,
				payload: res.data,
			});
			dispatch(loadUser());
		} catch (err) {
			dispatch({ type: REGISTER_FAILURE });
		}
	};

	// Login User

	const login = async (email, password) => {
		const config = {
			headers: {
				'Content-Type': 'application/json',
			},
		};

		const body = JSON.stringify({
			email,
			password,
		});

		try {
			const res = await axios.post('/api/auth', body, config);
			dispatch({
				type: LOGIN_SUCCESS,
				payload: res.data,
			});

			dispatch(loadUser());
		} catch (err) {
			dispatch({ type: LOGIN_FAILURE });
		}
	};

	const logout = () => {
		dispatch({ type: LOGOUT });
	};

	return (
		<AuthContext.Provider
			value={{
				token: state.token,
				user: state.user,
				isAuthenticated: state.isAuthenticated,
				loading: state.loading,
				register,
				loadUser,
				login,
				logout,
			}}>
			{props.children}
		</AuthContext.Provider>
	);
};

export default AuthState;
